import {
  types,
  applySnapshot
} from "mobx-state-tree";
import {
  Framework
} from "@flint/framework";

const EditUserModel = types
  .model("EditUserModel", {
    res: types.string,
    stat: types.string,
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("EDITING_USER_DATA");
    },
    set(response) {
      let status = response.data.response;
      let data;
      if (status === "SUCCESS") {
        data = `The user has been edited successfully! Please create a ticket on ServiceNow as well!`;
      } else if (status === "Null Values for IsAdmin/StartDate/EndDate is not allowed") {
        data = `Please select a start date and an end date for the admin!`;
      } else {
        console.log(status)
        data = status;
      }
      applySnapshot(self, {
        res: data,
        stat: status
      });
    },
    reset() {
      applySnapshot(self, {
        res: "Oops...Something went wrong. Please try again.",
        stat: ""
      });
    },
  }));

export default EditUserModel;